class CartNotification {
  constructor() {
    this.notification = document.getElementById('cart-notification');
    this.productContainer = document.getElementById('cart-notification-product');
    this.closeButton = this.notification?.querySelector('.cart-notification__close');
    this.continueButton = this.notification?.querySelector('.cart-notification__continue');
    this.viewCartButton = this.notification?.querySelector('.cart-notification__view-cart');
    this.timer = null;

    if (this.notification) {
      this.init();
    }
  }

  init() {
    this.closeButton?.addEventListener('click', () => this.hide());
    this.continueButton?.addEventListener('click', () => this.hide());
    this.viewCartButton?.addEventListener('click', () => {
      this.hide();
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
    
    // Listen for custom event to show notification
    document.addEventListener('cart:item-added', (event) => {
      this.show(event.detail.items);
    });
  }

  show(items) {
    if (!items || items.length === 0 || !this.notification) return;

    // Clear existing timer
    if (this.timer) clearTimeout(this.timer);

    // Populate product info
    this.productContainer.innerHTML = '';
    
    items.forEach(item => {
      const productHtml = `
        <div class="cart-notification-product__item">
          <img src="${item.image ? item.image : ''}" alt="${item.title}" class="cart-notification-product__image">
          <div class="cart-notification-product__info">
            <h3 class="cart-notification-product__name">${item.product_title || item.title}</h3>
            ${(() => {
              if (!item.variant_title || item.variant_title === 'Default Title') return '';
              const parts = item.variant_title.split(' / ');
              let html = '';
              if (parts[0]) html += `<p class="cart-notification-product__option">Cor: ${parts[0]}</p>`;
              if (parts[1]) html += `<p class="cart-notification-product__option">Tamanho: ${parts[1]}</p>`;
              return html;
            })()}
          </div>
        </div>
      `;
      this.productContainer.insertAdjacentHTML('beforeend', productHtml);
    });

    // Show notification
    this.notification.classList.add('active');

    // Auto hide after 5 seconds
    this.timer = setTimeout(() => {
      this.hide();
    }, 5000);
  }

  hide() {
    this.notification?.classList.remove('active');
    if (this.timer) clearTimeout(this.timer);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartNotification = new CartNotification();
});
